/**
 * @generated SignedSource<<7493329dfd50ddb8bc6f89f0c92f5ca8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ForgotPasswordInput = {
  email: string;
};
export type ProfileSettingsAccountTabMutation$variables = {
  input: ForgotPasswordInput;
};
export type ProfileSettingsAccountTabMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type ProfileSettingsAccountTabMutation = {
  response: ProfileSettingsAccountTabMutation$data;
  variables: ProfileSettingsAccountTabMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ForgotPasswordResponse",
    "kind": "LinkedField",
    "name": "forgotPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSettingsAccountTabMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileSettingsAccountTabMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72e1eec1fa5158431e5a97b1896638bd",
    "id": null,
    "metadata": {},
    "name": "ProfileSettingsAccountTabMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileSettingsAccountTabMutation(\n  $input: ForgotPasswordInput!\n) {\n  response: forgotPassword(input: $input) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d21d327849d1bec1c61e8526b33d6ca";

export default node;
